import { queryOptions } from '@tanstack/react-query'
import { numberApi } from './api'
import { PENDING_NUMBER_STATUSES, OrganizationNumber } from './models'

export const numberQueries = {
  all: () => ['numbers'],

  list: (organization: string | null | undefined) =>
    queryOptions({
      queryKey: [...numberQueries.all(), organization],
      queryFn: () => numberApi.csc.listForOrg({ organization: organization! }),
      enabled: Boolean(organization),
      // Poll while any number is still provisioning so a just-subscribed number
      // visibly advances to `active` without a manual refresh.
      refetchInterval: (query) => {
        const data = query.state.data as OrganizationNumber[] | undefined
        const settling = data?.some((n) => PENDING_NUMBER_STATUSES.includes(n.status))
        return settling ? 4000 : false
      },
    }),

  /** Chat-facing: an org's sendable numbers, readable without numbers.manage. */
  sendable: (organization: string | null | undefined) =>
    queryOptions({
      queryKey: [...numberQueries.all(), 'sendable', organization],
      queryFn: () => numberApi.csc.listSendableForOrg({ organization: organization! }),
      enabled: Boolean(organization),
    }),

  /** Chat-facing: sendable-status flag per org the caller belongs to (one read). */
  sendableSummary: () =>
    queryOptions({
      queryKey: [...numberQueries.all(), 'sendable-summary'],
      queryFn: () => numberApi.csc.sendableSummary(),
      // A just-provisioned number should light up its org card without a reload;
      // a short interval keeps the selector's status indicator live.
      refetchInterval: 15000,
    }),
}
